import * as authActions from "../../reduxV2/auth/auth.actions";
export var isPerformingSubmitActionSelector = function () { return function (state) {
    return state.AUTH_V2.isSigningIn || state.auth.isFetchingUser;
}; };
export var performingSubmitActionResultSelector = function () { return function (state) {
    return state.auth.user;
}; };
export var performingSubmitActionErrorSelector = function () { return function (state) {
    return state.AUTH_V2.signInError || state.auth.fetchUserError;
}; };
export var submitActionCreator = function () { return function (formData) {
    return authActions.signInAutomaticallyStart.getAction(formData);
}; };
